import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 34 34\" id=\"icon-edit\">\r\n<path d=\"M15.9,24.7L7,28l3.3-8.9L15.9,24.7z M17.1,23.6l-5.6-5.6L24,5.5l5.6,5.6L17.1,23.6z M30.7,10l-5.6-5.6l2.8-2.8l5.6,5.6\r\n\tL30.7,10z M0,0h16v2H0V0z M0,0h2v34H0V0z M32,17h2v17h-2V17z M0,32h33v2H0V32z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/edit.svg
// module id = 281
// module chunks = 0 1